import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConfirmModalComponent } from 'src/app/confirm-modal/confirm-modal.component';
import { Batch, Category } from 'src/app/_models';
import { CatalogService,  UtilsService } from 'src/app/_services';
import { BasketService } from 'src/app/_services/basket.service';
import { environment } from 'src/environments/environment';

declare const $ : any ;

@Component({
  selector: 'app-product-batch-modal',
  templateUrl: './product-batch-modal.component.html',
  styleUrls: ['./product-batch-modal.component.css']
})
export class ProductBatchModalComponent implements OnInit {

  public category : Category;
  public totalPrice : number;
  public batch : Batch;
  public base_image_url : string;
  public in_basket : number;

  constructor(
    public catalog : CatalogService,
    public translate : TranslateService,
    public utils : UtilsService,
    public basket : BasketService,
    public toastr : ToastrService
  ) {
    this.base_image_url = environment.BASE_IMAGE_URL;
   }

  ngOnInit() {
    this.in_basket = 0;
    this.batch = new Batch();
  }

  setCategory( category : Category){
    this.category = category;
    this.basket.getBatches(category.id).subscribe(result =>{
      this.batch = result;
      this.in_basket = this.batch.batch_qty;
      if (this.batch.batch_qty == 0){
          this.batch.batch_qty = 1;
      }
      this.recalcPrice();
    });
  }

  less(){
    if (this.batch.batch_qty > 1){
      this.batch.batch_qty -= 1;
    }
    else {
      this.batch.batch_qty = 1;
    }
    this.recalcPrice();
  }

  more(){
    this.batch.batch_qty += 1;
    this.recalcPrice();
  }

  recalcPrice(){
      this.totalPrice = this.batch.batch_qty * this.category.batch_price ;
  }

  add(){
    this.basket.addBatch(this.category, this.batch).subscribe(result =>{
      $('#modal-batch-product').modal('hide');      
    });  
  }

  removeAll(){
    this.batch.flag_action = false;
    this.batch.batch_qty = 0;
    this.basket.removeBatch(this.category, this.batch).subscribe(result =>{
      $('#modal-batch-product').modal('hide');      
    });  
  }



}
